import React from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import { toggleTheme, useDarkMode } from "../lib/theme";

const ThemeToggle = () => {
    const dark = useDarkMode();
    const label = dark ? "Switch to light theme" : "Switch to dark theme";

    return (
        <button
            type="button"
            onClick={(event) => toggleTheme(event.currentTarget)}
            aria-label={label}
            title={label}
            className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-fg/15 text-fg transition-[border-color,transform] duration-300 hover:border-fg/50 active:scale-95"
        >
            {dark ? <FiSun size={16} aria-hidden="true" /> : <FiMoon size={16} aria-hidden="true" />}
        </button>
    );
};

export default ThemeToggle;
